/* eslint-disable */
window.VizEdge = {};
